module.exports = __webpack_public_path__ + "img/kachel-HERZKREISLAUF-ALOEVERATRINKGELSIVERA.32f71bf0.png";